import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { GetCountries, GetState } from 'react-country-state-city';
import { useEffect, useState } from 'react';

export const EditSenderAddressModal = ({ formik, isReturnShipmentTab, show, handleClose, formData, setFormData, handleChange, handleCheckChange, saveData }) => {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);

    useEffect(() => {
        const getCountries = async () => {
            const countries = await GetCountries();
            setCountries(countries);
            setStatesDropdown(countries);
        }
        const setStatesDropdown = async (countries) => {
            const defaultCountry = countries.find((c) => c.iso2 === 'US');
            const statesData = await GetState(defaultCountry.id);
            setStates(statesData);
        }

        getCountries();
    }, []);

    const handleCountryChange = async (e) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            country: value,
            state: '',
            city: ''
        });
        const selectedCountry = countries.find((c) => c.iso2 === value);
        if (!selectedCountry) return setStates([]);
        const statesData = await GetState(selectedCountry.id);
        setStates(statesData);
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>View/Edit Sender</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <strong>Changes made here will only apply to current shipment. Selecting a new sender in the dropdown will discard changes.</strong>
                <br/>
                <br/>
                <Row className='form-group'>
                    <Form.Group as={Col}>
                        <Form.Label>Contact name</Form.Label>
                        <Form.Control
                            name='contactName'
                            value={formData.contactName}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label>Company name</Form.Label>
                        <Form.Control
                            name='companyName'
                            value={formData.companyName}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Row>
                <Row className='form-group'>
                    <Form.Group as={Col}>
                        <Form.Label>Country</Form.Label>
                        <Form.Select
                            name='country'
                            value={formData.country}
                            onChange={handleCountryChange}
                        >
                            <option value=''>Select an option</option>
                            {
                                countries.map((c) => (
                                    <option key={c.id} value={c.iso2}>{c.iso2} - {c.name}</option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label>Postal code</Form.Label>
                        <Form.Control
                            name='postalCode'
                            value={formData.postalCode}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Row>
                <Row className='form-group'>
                    <Form.Group as={Col}>
                        <Form.Label>Address 1</Form.Label>
                        <Form.Control
                            name='address1'
                            value={formData.address1}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label>Address 2</Form.Label>
                        <Form.Control
                            name='address2'
                            value={formData.address2}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Row>
                <Row className='form-group'>
                    <Form.Group as={Col}>
                        <Form.Label>State</Form.Label>
                        <Form.Select
                            name='state'
                            value={formData.state}
                            onChange={handleChange}
                        >
                            <option value=''>Select an option</option>
                            {
                                states.map((s) => (
                                    <option key={s.id} value={s.state_code}>{s.state_code} - {s.name}</option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label>City</Form.Label>
                        <Form.Control
                            name='city'
                            value={formData.city}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Row>
                <Row className='form-group'>
                    <Form.Group as={Col}>
                        <Form.Label>Telephone</Form.Label>
                        <Form.Control
                            name='telephone'
                            value={formData.telephone}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            name='email'
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Row>
                <Form.Check
                    type='checkbox'
                    name='residentialAddress'
                    label='This is a residential address'
                    checked={formData.residentialAddress}
                    onChange={handleCheckChange}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={saveData} className='purple-btn'>Ok</Button>
                <Button onClick={handleClose} variant='secondary'>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}